import React from "react";
import image_1 from "../../images/afro-academy/Picture25.png";
import image_2 from "../../images/afro-academy/Picture26.png";
import image_3 from "../../images/afro-academy/Picture27.png";

const TrainingCenter = () => {
  return (
    <section className="pt-7">
      <div className="text-center">
        <h1 className="fs-28 gilroy-bold">Our Local Chapters</h1>
        <h2 className="fs-56 lh-64 gilroy-bold">Training Centers</h2>
      </div>

      <div className="row pt-7 training-center-card-height">
        <div className="col-md-6 col-xl-6 bg-bright-gray h-100 d-flex align-items-center justify-content-center">
          <div className="">
            <img src={image_1} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-4 mb-md-0 px-4 px-lg-0 py-3 py-lg-0 bg-chinese-black text-white h-100 d-flex align-items-center justify-content-center">
          <div className="text-center text-md-start">
            <h3 className="fs-28 gilroy-bold">London, UK</h3>
            <div className="fs-20">
              <p>Tel: +44 7535 049092</p>
              <p>Email: admin@institutdeIDL.org</p>
              <p> HQ Address: 88 Hatton Garden London EC1N 8PN, UK</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row training-center-card-height">
        <div className="col-md-6 col-xl-6 bg-chinese-black h-100 d-flex align-items-center justify-content-center">
          <div className="py-5 py-md-0">
            <img src={image_2} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-4 mb-md-0 px-4 px-lg-0 py-3 py-lg-0 bg-bright-gray h-100 d-flex align-items-center justify-content-center">
          <div className="text-center text-md-start">
            <h3 className="fs-28 gilroy-bold">Dubai, UAE</h3>
            <div className="fs-20">
              <p>Tel: +971 4 23 888 42</p>
              <p>Mobile: +971 50 109 8055</p>
              <p>Email: contact@hicenter.ae</p>
              <p>
                HQ Address: Mei Tower Al Nahda 1 Dubai, United Arab Emirates
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row training-center-card-height">
        <div className="col-md-6 col-xl-6 bg-bright-gray h-100 d-flex align-items-center justify-content-center">
          <div className="">
            <img src={image_3} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 px-4 px-lg-0 py-3 py-lg-0 bg-chinese-black text-white h-100 d-flex align-items-center justify-content-center">
          <div className="text-center text-md-start">
            <h3 className="fs-28 gilroy-bold">Cairo, EGYPT</h3>
            <div className="fs-20">
              <p>Tel. (+20) 2 38367340/9</p>
              <p>Email: academy@afro-group.com</p>
              <p>
                (18/1/4) Farrag Mall, Central Axis 2nd District, 6 th octobar ,
                Giza , Egypt
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingCenter;
